import { Container, ContainerSucces } from './styles'
import { useForm, ValidationError } from '@formspree/react'
import emailjs from '@emailjs/browser'
// import { SMTPClient, Message } from 'emailjs';
import { toast, ToastContainer } from 'react-toastify'
import ReCAPTCHA from 'react-google-recaptcha'
import { useEffect, useState, useRef } from 'react'
import validator from 'validator'


export function Form() {
  const [state, handleSubmit] = useForm('myyozglw')
  const [isActive, setIsActive] = useState(false)
  // const form = useRef();
  const [validEmail, setValidEmail] = useState(false)
  const [email, setEmail] = useState('')
  const [isHuman, setIsHuman] = useState(false)
  const [message , setMessage] = useState('')

  function verifyEmail(email: string) {
    if (validator.isEmail(email)) {
      setValidEmail(true)
      setEmail(email)
    } else {
      setValidEmail(false)
    }
  }
  

  const sendEmail = async (e: React.FormEvent<EventTarget>) => {
    e.preventDefault();
    const msg = {
      subject: `Email from ${email}`,
      message: message,
      email: email,
    };
    console.log(msg);
    await emailjs.send('//service_uys91x1', 'template_hbj2yf2', msg , '//user_OkvbmVlSu88GZVQuCiObK')
    .then((result) => {
        console.log(result.text);
        toast.success('Email sended sucessfully!', {
          position: toast.POSITION.BOTTOM_LEFT,
          pauseOnFocusLoss: false,
          closeOnClick: true,
          hideProgressBar: false,
          toastId: 'succeeded',
        })
        setIsActive(true);
    }, (error) => {
        console.log(error.text);
        toast.error('some error occured, please try again later', {
          position: toast.POSITION.BOTTOM_LEFT,
          pauseOnFocusLoss: false,
          closeOnClick: true,
          hideProgressBar: false,
          toastId: 'error',
        })
    });
  }
  if (isActive) {
    return (
      <ContainerSucces>
        <h3>Thank you</h3>
        <button
          onClick={() => {
            window.scrollTo({ top: 0, behavior: 'smooth' })
          }}
        >
          Thankss
        </button>
        <ToastContainer />
      </ContainerSucces>
    )
  }

  return (
    <Container>
      <h2>Get in touch using the form below</h2>
      <form onSubmit={sendEmail}>
        <input
          placeholder="Email"
          id="email"
          type="email"
          name="email"
          onChange={(e) => {
            verifyEmail(e.target.value)
          }}
          required
        />
        <ValidationError prefix="Email" field="email" errors={state.errors} />
        <textarea
          required
          placeholder="Type your message here"
          id="message"
          name="message"
          onChange={(e) => {
            setMessage(e.target.value)
          }}
        />
        <ValidationError
          prefix="Message"
          field="message"
          errors={state.errors}
        />
        <ReCAPTCHA
          sitekey="6LfT700eAAAAALjLGMqGpgOT-Ln31M4mTpsVfKF3"
          onChange={(e) => {
            setIsHuman(true)
          }}
        ></ReCAPTCHA>
        <button
          type="submit"
          disabled={state.submitting || !validEmail || !message || !isHuman}
        >
          To Send
        </button>
      </form>
      <ToastContainer />
    </Container>
  )
}
